import React from "react";

export default function MSAccess_Atn() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Atn</h1>
      <p>This is the MSAccess_Atn component generated from the SQL JSON.</p>
    </div>
  );
}
